/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmissionGetRequest
 */
export interface SubmissionGetRequest {
    /**
     * 
     */
    ids: Array<string>;
}

/**
 * Check if a given object implements the SubmissionGetRequest interface.
 */
export function instanceOfSubmissionGetRequest(value: object): value is SubmissionGetRequest {
    if (!('ids' in value) || value['ids'] === undefined) return false;
    return true;
}

export function SubmissionGetRequestFromJSON(json: any): SubmissionGetRequest {
    return SubmissionGetRequestFromJSONTyped(json, false);
}

export function SubmissionGetRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmissionGetRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ids': json['ids'],
    };
}

export function SubmissionGetRequestToJSON(json: any): SubmissionGetRequest {
    return SubmissionGetRequestToJSONTyped(json, false);
}

export function SubmissionGetRequestToJSONTyped(value?: SubmissionGetRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ids': value['ids'],
    };
}

